"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var react_native_web_swiper_1 = __importDefault(require("react-native-web-swiper"));

var Icon_1 = require("../Icon/Icon");

exports.SwiperComponent = function (props) {
  var children = props.children,
      controlsEnabled = props.controlsEnabled,
      slideWrapperStyle = props.slideWrapperStyle,
      controlsPressHandler = props.controlsPressHandler;
  var controlsEnabledProps = {
    dotsTouchable: false,
    dotsPos: false,
    prevPos: 'left',
    nextPos: 'right',
    PrevComponent: function PrevComponent(_a) {
      var _onPress = _a.onPress;
      return react_1.default.createElement(react_native_1.TouchableOpacity, {
        onPress: function onPress() {
          _onPress(); // tslint:disable-next-line: no-unused-expression


          controlsPressHandler && controlsPressHandler();
        }
      }, react_1.default.createElement(Icon_1.Icon, {
        name: "chevron-left-circle",
        size: Icon_1.IconSizeEnum.small
      }));
    },
    NextComponent: function NextComponent(_a) {
      var _onPress2 = _a.onPress;
      return react_1.default.createElement(react_native_1.TouchableOpacity, {
        onPress: function onPress() {
          _onPress2(); // tslint:disable-next-line: no-unused-expression


          controlsPressHandler && controlsPressHandler();
        }
      }, react_1.default.createElement(Icon_1.Icon, {
        name: "chevron-right-circle",
        size: Icon_1.IconSizeEnum.small
      }));
    }
  };

  if (controlsEnabled) {
    return react_1.default.createElement(react_native_web_swiper_1.default, {
      innerContainerStyle: slideWrapperStyle,
      controlsEnabled: controlsEnabled,
      controlsProps: controlsEnabledProps
    }, children);
  }

  return react_1.default.createElement(react_native_web_swiper_1.default, {
    innerContainerStyle: slideWrapperStyle,
    controlsEnabled: controlsEnabled
  }, children);
};